import { render, staticRenderFns } from "./sub-nav.vue?vue&type=template&id=23158187&scoped=true&"
import script from "./sub-nav.vue?vue&type=script&lang=js&"
export * from "./sub-nav.vue?vue&type=script&lang=js&"
import style0 from "./sub-nav.vue?vue&type=style&index=0&id=23158187&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23158187",
  null
  
)

export default component.exports